import React, { Component } from 'react';
import { Input, Label, Button, Tooltip } from 'reactstrap';
import './Milestones.css';
import Nav from '../../nav/Nav';
import Back from '../../Back';
import Library from '../../../scene/utility/Library';
import Lightbox from '../../utility/Lightbox';
import Loader from '../../utility/Loader';
import Img from '../../../StableImage';
import sourceallmilestones from '../../../library/milestones.json';
import { localizeContent, translate } from '../../../ContentTranslation';

import User from '../../../User';
import { read } from '../../../TextManager';

const allmilestones = localizeContent(sourceallmilestones);

const ZEN_MILESTONE_IMAGE = "https://moa-pull.b-cdn.net/assets/ui/zen%20milestone.png";

export default class Milestones extends Component {

  state = {
    focus: null
  }

  getMilestoneImage (ms) {

    if (this.isZenMilestoneImage(ms))
      return ZEN_MILESTONE_IMAGE;
    if (Array.isArray(ms.img))
      return ms.img[this.getMilestoneImageIndex(ms)] || null;
    return ms.img;
  }

  isGlobalMilestone (ms) {

    return User.isGlobalMilestone(ms.key);
  }

  getMilestoneImageIndex (ms) {

    if (this.isGlobalMilestone(ms))
      return Array.isArray(ms.img) ? 0 : null;

    const unlocked = User.checkMilestone(ms.key);
    if (unlocked < 2)
      return null;
    return Math.min(unlocked - 2, Array.isArray(ms.img) ? ms.img.length - 1 : 0);
  }

  getUnlockedImageIndexes (ms) {

    if (this.isGlobalMilestone(ms))
      return Array.isArray(ms.img) && ms.img[0] ? [0] : [];

    const unlocked = User.checkMilestone(ms.key);
    if (!Array.isArray(ms.img) || unlocked < 2)
      return [];
    return ms.img.map((_, i) => i).filter(i => i <= unlocked - 2 && ms.img[i]);
  }

  focusMilestone (ms, unlockedMilestones) {

    this.setState({focus: ms, focusImageIndex: this.getMilestoneImageIndex(ms), unlockedMilestones});
  }

  getFocusDifficulty (ms, imageIndex) {

    if (this.isGlobalMilestone(ms))
      return null;

    if (User.checkMilestone(ms.key) === 1 || imageIndex === null || imageIndex === undefined)
      return "zen";
    return ["casual", "challenge", "hardcore"][imageIndex];
  }

  isZenMilestoneImage (ms, imageIndex=this.getMilestoneImageIndex(ms)) {

    return !this.isGlobalMilestone(ms) && this.getFocusDifficulty(ms, imageIndex) === "zen";
  }

  getNextMilestoneImageIndex (imageIndexes, imageIndex) {

    if (!imageIndexes || imageIndexes.length <= 1)
      return null;
    const imagePosition = imageIndexes.findIndex(i => i === imageIndex);
    if (imagePosition < 0)
      return imageIndexes[0];
    return imageIndexes[(imagePosition + 1) % imageIndexes.length];
  }

  getDifficultyName (difficulty) {

    switch (difficulty) {
    case "zen": return "Zen";
    case "casual": return "Casual";
    case "challenge": return "Challenge";
    case "hardcore": return "Hardcore";
    default: return "";
    }
  }

  renderMilestone (ms, unlockedMilestones, key) {

    let img = this.getMilestoneImage(ms);
    let unlocked = User.checkMilestone(ms.key);
    let zenImage = this.isZenMilestoneImage(ms);

    return (
      <div
        key={key}
        className={"milestone" + (unlocked ? " unlocked" : "") + (zenImage ? " zen-milestone" : "")}
        onClick={unlocked ? () => this.focusMilestone(ms, unlockedMilestones) : null}
      >
        {
          unlocked ? (img ? <><Img src={img}/>{ zenImage && <div className="milestone-zen-requirement">{ms.requirement}</div> }</> : <div className="milestone-blank"/>) : <div className="milestone-lock-message">{ms.requirement}</div>
        }
      </div>
    );
  }

  renderFocus (unlockedMilestones) {

    if (!this.state.focus)
      return null;

    let focus = this.state.focus;
    let imageIndexes = this.getUnlockedImageIndexes(focus);
    let imageIndex = imageIndexes.includes(this.state.focusImageIndex) ? this.state.focusImageIndex : this.getMilestoneImageIndex(focus);
    let nextImageIndex = this.getNextMilestoneImageIndex(imageIndexes, imageIndex);
    let focusDifficulty = this.getFocusDifficulty(focus, imageIndex);
    let img = this.isZenMilestoneImage(focus, imageIndex) ? ZEN_MILESTONE_IMAGE : (Array.isArray(focus.img) ? focus.img[imageIndex] : focus.img);
    let zenImage = this.isZenMilestoneImage(focus, imageIndex);
    let index = unlockedMilestones.findIndex(ms => ms.key === focus.key);
    let left = index > 0 ? unlockedMilestones[index - 1] : null;
    let right = index >= 0 && index < unlockedMilestones.length - 1 ? unlockedMilestones[index + 1] : null;

    return (
      <Lightbox className="milestone-focus-box" open={true} onClose={() => this.setState({focus: null})}>
        <div className="milestone-focus">
          { left ? <div onClick={() => this.focusMilestone(left, unlockedMilestones)} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
          { right ? <div onClick={() => this.focusMilestone(right, unlockedMilestones)} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
          <h1>{focus.title || focus.requirement}</h1>
          <div className={"milestone-focus-difficulty" + (focusDifficulty ? " " + focusDifficulty + "-difficulty" : " empty-difficulty")}>{focusDifficulty ? this.getDifficultyName(focusDifficulty) : ""}</div>
          <div className={"milestone-focus-image" + (zenImage ? " zen-milestone" : "")}>
            {
              focusDifficulty && nextImageIndex !== null ?
              <div className="milestone-difficulty-art-switch" onClick={() => this.setState({focusImageIndex: nextImageIndex})}>
                <Img alt="" src={"/images/" + focusDifficulty + ".png"}/>
              </div> : ""
            }
            { img ? <Img src={img}/> : <div className="milestone-blank"/> }
            { zenImage && <div className="milestone-zen-requirement">{focus.requirement}</div> }
          </div>
          { focus.reward ? <div className="milestone-focus-reward">{focus.reward}</div> : "" }
        </div>
      </Lightbox>
    );
  }

  meetsPreviewRequirement (ms, championKey) {

    if (!ms.preview || User.checkMilestone(ms.key))
      return true;

    return Object.keys(ms.preview).every(key => {
      switch (key) {
      case "level": {
        if (!championKey)
          return false;
        const data = User.dataFor(championKey, "zen");
        return data.level >= ms.preview[key];
      }
      case "hasSeen":
        return User.hasSeen(ms.preview[key]);
      case "milestone":
        return User.checkMilestone(ms.preview[key]) > 0;
      default:
        return false;
      }
    });
  }

  render () {

    let globalmilestones = Object.values(allmilestones[0] || {}).filter(ms => this.meetsPreviewRequirement(ms, 0)).sort((a, b) => a.order - b.order);
    let charactermilestones = Object.values(allmilestones[User.champion] || {}).filter(ms => this.meetsPreviewRequirement(ms, User.champion)).sort((a, b) => a.order - b.order);
    let unlockedMilestones = [...globalmilestones, ...charactermilestones].filter(ms => User.checkMilestone(ms.key));

    return (
      <div className={"main-page milestones-page champion-" + User.champion}>
        { this.renderFocus(unlockedMilestones) }
        <div className="main-background">
          <img src="/images/background.png"/>
        </div>
        <Nav/>
        <div className="main">
          <div className="milestones">
            <div className="milestone-list-title">{translate("Global")}</div>
            <div className="milestone-list">
              <div className="milestone-list-inner">
                {
                  globalmilestones.map(ms => this.renderMilestone(ms, unlockedMilestones, "global-" + ms.key))
                }
              </div>
            </div>
            <div className="milestone-list-title">{Library.getChampion(User.champion).name}</div>
            <div className="milestone-list">
              <div className="milestone-list-inner">
                {
                  charactermilestones.map(ms => this.renderMilestone(ms, unlockedMilestones, "champion-" + ms.key))
                }
              </div>
            </div>
          </div>
        </div>
        <Back to="/play"/>
      </div>
    );
  }
}
